module.exports = __webpack_public_path__ + "static/media/living room-05.5122ed7d.jpg";